module.exports = __webpack_public_path__ + "img/mis-direcciones-bco.afe03ee1.svg";